export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_SIGN_UP = 'USER_SIGN_UP';
export const USER_SIGN_UP_SUCCESS = 'USER_SIGN_UP_SUCCESS';
export const USER_SIGN_UP_FAIL = 'USER_SIGN_UP_FAIL';
export const USER_PASSWORD_RESET = 'USER_PASSWORD_RESET';
export const USER_PASSWORD_RESET_SUCCESS = 'USER_PASSWORD_RESET_SUCCESS';
export const USER_PASSWORD_RESET_FAIL = 'USER_PASSWORD_RESET_FAIL';
export const USER_PASSWORD_NEW = 'USER_PASSWORD_NEW';
export const USER_PASSWORD_NEW_SUCCESS = 'USER_PASSWORD_NEW_SUCCESS';
export const USER_PASSWORD_NEW_FAIL = 'USER_PASSWORD_NEW_FAIL';
export const USER_CONFIRM = 'USER_CONFIRM';
export const USER_CONFIRM_SUCCESS = 'USER_CONFIRM_SUCCESS';
export const USER_CONFIRM_FAIL = 'USER_CONFIRM_FAIL';
export const LOAD_USER = 'LOAD_USER';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_FAIL = 'LOAD_USER_FAIL';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL';


export const FETCH_SERIES = 'FETCH_SERIES';
export const FETCH_SERIES_SUCCESS = 'FETCH_SERIES_SUCCESS';
export const FETCH_SERIES_FAIL = 'FETCH_SERIES_FAIL';
export const FETCH_SERIE_RESULT = 'FETCH_SERIE_RESULT';
export const FETCH_SERIE_RESULT_SUCCESS = 'FETCH_SERIE_RESULT_SUCCESS';
export const FETCH_SERIE_RESULT_FAIL = 'FETCH_SERIE_RESULT_FAIL';
export const SET_CURRENT_SERIE = 'SET_CURRENT_SERIE';
export const NEXT_QUESTION = 'NEXT_QUESTION';
export const FETCH_QUESTION = 'FETCH_QUESTION';
export const FETCH_QUESTION_SUCCESS = 'FETCH_QUESTION_SUCCESS';
export const FETCH_QUESTION_FAIL = 'FETCH_QUESTION_FAIL';
export const SEND_ANSWER = 'SEND_ANSWER';
export const SEND_ANSWER_SUCCESS = 'SEND_ANSWER_SUCCESS';
export const SEND_ANSWER_FAIL = 'SEND_ANSWER_FAIL';
export const ASK_QUESTION = 'ASK_QUESTION';
export const ASK_QUESTION_SUCCESS = 'ASK_QUESTION_SUCCESS';
export const ASK_QUESTION_FAIL = 'ASK_QUESTION_FAIL';

export const QUESTION_ASKED = 'QUESTION_ASKED';
export const QUESTION_ANSWERED = 'QUESTION_ANSWERED';
export const CLEAN_QUESTION = 'CLEAN_QUESTION';

export const FETCH_RESULTS = 'FETCH_RESULTS';
export const FETCH_RESULTS_SUCCESS = 'FETCH_RESULTS_SUCCESS';
export const FETCH_RESULTS_FAIL = 'FETCH_RESULTS_FAIL';
export const FETCH_RESULT = 'FETCH_RESULT';
export const FETCH_RESULT_SUCCESS = 'FETCH_RESULT_SUCCESS';
export const FETCH_RESULT_FAIL = 'FETCH_RESULT_FAIL';